import React from 'react';

import { useOrderDetailContext } from 'providers/OrderDetailProvider';

import Table from 'components/common/Table';
import OrderReturnExpandedRow from 'components/add_order/order/OrderDetail/OrderReturns/OrderReturnExpandedRow';

import { shipmentApi } from 'api';
import { ORDER_DETAIL_RETURNS_COLUMNS } from 'constants/order';

const OrderReturns = ({ orderId }) => {
  const { orderDetailData } = useOrderDetailContext();

  return (
    <Table
      title={`Order #${orderDetailData?.channelOrderId} Returns`}
      apiService={shipmentApi}
      columns={ORDER_DETAIL_RETURNS_COLUMNS}
      fetchConfig={{
        method: 'getReturns',
        enablePagination: true,
      }}
      resourceId={orderId}
      renderExpandedRow={row => (
        <OrderReturnExpandedRow shipment={row.original} />
      )}
    />
  );
};

export default OrderReturns;
